import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Card, FlexView, Button, Icon } from 'components/common'
import { Input } from 'components/form'
import styled from 'styled-components'
import { xml2js } from 'xml-js'
import { TransportContext } from 'stores/ManagementTransportStore'

const Title = styled.h1`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
`
const AttachCTeModal = ({ isOpen, onOutsideClick, title, data }) => {
	const { t } = useTranslation()
	const [attach, setAttach] = useState([])
	const [CTE, setCTE] = useState([])
	const [keyAttach, setKeyAttach] = useState([])
	const [keyCTE, setKeyCTE] = useState([])
	const [transport, setTransport] = useState([])
	// const [disable, setDisable] = useState(true)
	const { sendAttachment } = useContext(TransportContext)
	const [file, setFile] = useState([])

	useEffect(() => {
		setTransport(Object.assign(transport, data.transportInformation, data.taxInformation, data.otherInformation))
	}, [data, transport])

	const removeAccent = (value) => {
		return String(value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
	}

	const validateXML = (xmlTransport, xmlVall) => {
		let count = 0
		const objCTE = {
			remxNome: xmlVall.rem.xNome._text,
			remCNPJ: xmlVall.rem.CNPJ._text,
			destxNome: xmlVall.dest.xNome._text,
			destCNPJ: xmlVall.dest.CNPJ._text,
			expedxNome: xmlVall.exped.xNome._text,
			expedCNPJ: xmlVall.exped.CNPJ._text,
			recebxNome: xmlVall.receb.xNome._text,
			recebCNPJ: xmlVall.receb.CNPJ._text
		}

		setCTE(objCTE)
		setKeyCTE(Object.keys(objCTE))


		Object.keys(xmlTransport).map((item) => {
			if (item === 'shippingCompany') {
				if (!removeAccent(attach[item]).includes(removeAccent(transport[item]))) {
					count++
				}
			} else {
				if (removeAccent(attach[item]) !== removeAccent(transport[item])) {
					count++
				}
			}
			return count
		})

		Object.keys(objCTE).map((item) => (
			removeAccent(CTE[item]) === removeAccent(data.cte.item) ? null : count++
		))
		// count > 0 ? setDisable(true) : setDisable(false)
	}

	const creatAttachMD = (xml) => {
		let frete = 0
		let pedagio = 0
		let advalorem = 0
		let vicms = 0
		if (xml.vPrest.Comp.length > 0) {
			xml.vPrest.Comp.map((item) => (
				item.xNome._text === "TARIFA DE FRETE" ?
					frete = item.vComp._text :
					item.xNome._text === "Pedagio" ?
						pedagio = item.vComp._text :
						item.xNome._text === "SEGURO DA CARGA" ?
							advalorem = item.vComp._text :
							item.xNome._text === "Valor do ICMS" ?
								vicms = item.vComp._text :
								null
			))
		} else {
			if (xml.vPrest.Comp.xNome._text === "TARIFA DE FRETE")
				frete = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "Pedagio")
				pedagio = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "SEGURO DA CARGA")
				advalorem = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "Valor do ICMS")
				vicms = xml.vPrest.Comp.vComp._text
		}

		const obj = {
			origin: xml.ide.xMunIni._text,
			destination: xml.ide.xMunFim._text,
			shippingCompany: xml.emit.xNome._text,
			shippingPrice: frete,
			maxToll: pedagio,
			insurancePrice: advalorem,
			invoicePrice: xml.infCTeNorm.infCarga.vCarga._text,
			icmsPorcentage: vicms !== 0 ? vicms : xml.imp.ICMS.ICMS00.vICMS._text,
			totalPrice: xml.vPrest.vTPrest._text,
			cteCarrier: xml.ide.nCT._text
		}
		setAttach(obj)
		setKeyAttach(Object.keys(obj))
		validateXML(obj, xml)
	}

	const createAttachVIX = (xml) => {
		let frete = 0
		let pedagio = 0
		let advalorem = 0

		if (xml.vPrest.Comp.length > 0) {
			xml.vPrest.Comp.map((item) => (
				item.xNome._text === "FRETE" ?
					frete = item.vComp._text :
					item.xNome._text === "PEDAGIO" ?
						pedagio = item.vComp._text :
						item.xNome._text === "SEGURO" ?
							advalorem = item.vComp._text :
							null
			))
		} else {
			if (xml.vPrest.Comp.xNome._text === "FRETE")
				frete = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "PEDAGIO")
				pedagio = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "SEGURO")
				advalorem = xml.vPrest.Comp.vComp._text
		}

		const obj = {
			origin: xml.ide.xMunIni._text,
			destination: xml.ide.xMunFim._text,
			shippingCompany: xml.emit.xNome._text,
			shippingPrice: frete,
			maxToll: pedagio,
			insurancePrice: advalorem,
			invoicePrice: xml.infCTeNorm.infCarga.vCarga._text,
			icmsPorcentage: xml.imp.ICMS.ICMS00.vICMS._text,
			totalPrice: xml.imp.ICMS.ICMS00.vBC,
			cteCarrier: xml.ide.nCT._text
		}
		setAttach(obj)
		setKeyAttach(Object.keys(obj))
		validateXML(obj, xml)
	}

	const createAttachMANCHUR = (xml) => {
		let frete = 0
		let pedagio = 0
		let advalorem = 0
		if (xml.vPrest.Comp.length > 0) {
			xml.vPrest.Comp.map((item) => (
				item.xNome._text === "FreteMercadoria" ?
					frete = item.vComp._text :
					item.xNome._text === "TaxaPedagio" ?
						pedagio = item.vComp._text :
						item.xNome._text === "AdValorem" ?
							advalorem = item.vComp._text :
							null
			))
		} else {
			if (xml.vPrest.Comp.xNome._text === "FreteMercadoria")
				frete = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "TaxaPedagio")
				pedagio = xml.vPrest.Comp.vComp._text
			if (xml.vPrest.Comp.xNome._text === "AdValorem")
				advalorem = xml.vPrest.Comp.vComp._text
		}

		const obj = {
			origin: xml.ide.xMunIni._text,
			destination: xml.ide.xMunFim._text,
			shippingCompany: xml.emit.xNome._text,
			shippingPrice: frete,
			maxToll: pedagio,
			insurancePrice: advalorem,
			invoicePrice: xml.infCTeNorm.infCarga.vCarga._text,
			icmsPorcentage: xml.imp.ICMS.ICMS90 ? xml.imp.ICMS.ICMS90.vICMS._text : xml.imp.ICMS.ICMS00.vICMS._text,
			totalPrice: xml.imp.ICMS.ICMS90 ? xml.imp.ICMS.ICMS90.vBC._text : xml.imp.ICMS.ICMS00.vBC._text,
			cteCarrier: xml.ide.nCT._text
		}
		setAttach(obj)
		setKeyAttach(Object.keys(obj))
		validateXML(obj, xml)
	}

	const readFile = (evt) => {
		setFile(evt)
		if (evt.type === "text/xml") {
			const fileReader = new FileReader()
			fileReader.readAsBinaryString(evt)
			fileReader.onload = (file) => {
				const xmlToJson = xml2js(file.target.result, { compact: true, spaces: 4 })
				if (evt.name.includes('XML MD')) {
					creatAttachMD(xmlToJson.cteProc.CTe.infCte)
				} else if (evt.name.includes('XML VIX')) {
					createAttachVIX(xmlToJson.cteProc.CTe.infCte)
				} else if (evt.name.includes('XML MANCHUR')) {
					createAttachMANCHUR(xmlToJson.cteProc.CTe.infCte)
				}
			}
		}
		// else {
		// 	setDisable(false)
		// }
	}

	useEffect(() => {
		setAttach([])
		setKeyAttach([])
		setCTE([])
		setKeyCTE([])
		setFile([])
	}, [onOutsideClick])

	return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
		<Card width="50%">
			<Title>{t(`transport.${title}`)}</Title>
			<Input width="100%" type='file' onChange={(e) => { readFile(e.target.files[0]) }} accept="application/xhtml+xml, application/xml, application/pdf" />
			<FlexView flexDirection="row" width="100%" justifyContent="space-between">
				<FlexView>
					{keyAttach.map((item, i) => (
						<FlexView key={i} padding="5px" flexDirection="row" width="100%" justifyContent="space-between" alignItems="center" style={{ border: '1px solid #B9B9B9' }}>
							{t(`transport.${item}`)}
							{item === 'shippingCompany' ? <>
								{
									removeAccent(attach[item]).includes(removeAccent(transport[item])) ?
										<Icon name="check" color="success" />
										: <Icon name="cross" color="error" />
								}
							</>
								:
								<>
									{
										removeAccent(attach[item]) === removeAccent(transport[item]) ?
											<Icon name="check" color="success" />
											: <Icon name="cross" color="error" />
									}
								</>

							}
						</FlexView>
					))}
				</FlexView>
				<FlexView margin='0px 15px'>
					{keyCTE.map((item, i) => (
						<FlexView key={i} padding="5px" flexDirection="row" width="100%" justifyContent="space-between" alignItems="center" style={{ border: '1px solid #B9B9B9' }}>
							{t(`transport.${item}`)}
							{removeAccent(CTE[item]) === removeAccent(data.cte[item]) ?
								<Icon name="check" color="success" />
								: <Icon name="cross" color="error" />
							}
						</FlexView>
					))}
				</FlexView>
			</FlexView>
			<FlexView width="100%" flexDirection="row" alignItems="center" justifyContent="flex-end" style={{ columnGap: '15px' }}>
				<Button onClick={() => { onOutsideClick() }}>
					{t('transport.cancel')}
				</Button>
				<Button backgroundColor='primary' color='white' onClick={async () => { await sendAttachment([file], 'CTE'); onOutsideClick() }}>
					{t(`transport.save`)}
				</Button>
			</FlexView>
		</Card>
	</Modal>
}

export default AttachCTeModal
